import { useRouteError } from "react-router-dom";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";

export const ErrorFallback = () => {
    const error = useRouteError();

    useEffect(() => {
        if (error) Sentry.captureException(error);
    }, [error]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center bg-white">
            <h1 className="text-2xl font-semibold mb-2">Er ging iets mis</h1>
            <p className="text-gray-600 mb-6">Herlaad de pagina om verder te gaan.</p>
            <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-primary text-white rounded"
            >
                Herlaad
            </button>
        </div>
    );
};
